import { getChecklist } from "./getChecklist";
import { getSchema } from "./getSchema";
import { submit } from "./submit";

export const employeeTaxFormsService = {
  getSchema,
  getChecklist,
  submit
};
